import { useRecoilValue } from 'recoil';
import { useActiveEditTarget } from './useActiveEditTarget';
import { useActiveFusionTarget } from './useActiveFusionTarget';
import type { Environment } from '~/engine/data/Environment';
import {
    activeVoiConsumerState,
    type VoiConsumer,
} from '~/state/atoms/toolsAtoms';

/**
 * The Environment whose views host the shared VOI box: the fused pair's
 * while registration owns the box, the edit target's while threshold
 * segmentation or the crop tab does, undefined while no consumer is active or the owner
 * has no resident Environment. A box is drawn on the views of the dataset
 * it belongs to and on no other.
 */
export function useVoiBoxHost(): Environment | undefined {
    const consumer = useRecoilValue(activeVoiConsumerState);
    const fusion = useActiveFusionTarget();
    const target = useActiveEditTarget();
    const hostOf: Record<VoiConsumer, Environment | undefined> = {
        registration: fusion.environment,
        'threshold-segmentation': target.environment,
        'post-processing-crop': target.environment,
    };
    return consumer ? hostOf[consumer] : undefined;
}
